export enum ControlSubstanceCode {
  SCHEDULE_0 = "0",
  SCHEDULE_1 = "1",
  SCHEDULE_2 = "2",
  SCHEDULE_3 = "3",
  SCHEDULE_4 = "4",
  SCHEDULE_5 = "5",
  SCHEDULE_U = "U",
  NON_SCHEDULE = "",
}

export const CONTROL_SUBSTANCE_CODE_OPTIONS = (
  Object.values(ControlSubstanceCode) as ControlSubstanceCode[]
).filter(
  (opt) =>
    opt !== ControlSubstanceCode.SCHEDULE_0 &&
    opt !== ControlSubstanceCode.SCHEDULE_1,
);

export const formatControlSubstanceCodeLabel = (code: string): string =>
  code === ControlSubstanceCode.NON_SCHEDULE ? "Non-Scheduled" : code;
